var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81406 1.152L5.42806 5.8C5.3718 5.86252 5.30302 5.91252 5.22618 5.94674C5.14935 5.98096 5.06617 5.99865 4.98206 5.99865C4.89795 5.99865 4.81478 5.98096 4.73794 5.94674C4.66111 5.91252 4.59233 5.86252 4.53606 5.8L0.186063 1.152C0.064379 1.02325 -0.0023413 0.852141 6.27838e-05 0.675C-0.000286174 0.503186 0.0648973 0.337705 0.182328 0.212285C0.299759 0.0868642 0.460597 0.0109449 0.632063 0L9.36806 0C9.53953 0.0109449 9.70037 0.0868642 9.8178 0.212285C9.93523 0.337705 10.0004 0.503186 10.0001 0.675C10.0025 0.852141 9.93575 1.02325 9.81406 1.152Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDown);
export default __webpack_public_path__ + "static/media/triangle_down.8e205286830fe3da9b59baf93bdffadb.svg";
export { ForwardRef as ReactComponent };